import { buildCtaRenderLocationElement, getAutomobileAssetData } from './utils';
import { StyleTag, createStyleTag } from '../../util/create-style-tag';
import Asset from '../../asset/asset';
import AssetWrapper from '../../asset/wrappers';
import AutomobileAsset from '../../asset/automobile-asset';
import Cta from '../../cta';
import AutomobileCta from '../../cta/automobile-cta';
import srpStyleContent from './style/srp.css';

export class HollerWPSrpAssetWrapper extends AssetWrapper<AutomobileAsset> {
  getDocumentStyles(): StyleTag[] {
    return [createStyleTag(srpStyleContent.toString(), 'srp-style')];
  }

  createCta(): Cta<Asset> {
    return new AutomobileCta(this, {
      style: 'standard'
    });
  }

  getRenderLocation(): HTMLElement {
    const badgeWrapperElement = this.container.querySelector('.dms-srp__badge-wrapper');
    if (!badgeWrapperElement) {
      throw new Error('Badge wrapper element is not loaded yet.');
    }
    const badgeWrapperParentElement = badgeWrapperElement.parentNode!;
    if (badgeWrapperParentElement?.querySelector('.ol-target-element') !== null) {
      return badgeWrapperParentElement.querySelector('.ol-target-element')!;
    }
    const ctaRenderLocation = buildCtaRenderLocationElement();
    badgeWrapperElement.before(ctaRenderLocation);
    return ctaRenderLocation;
  }

  parseAssetData(): AutomobileAsset {
    return getAutomobileAssetData(this.container);
  }

  static getPageContainer(): HTMLElement {
    const selector = '.dms-srp__body .dms-srp__vehicle-card-wrapper';
    const container = window.document.querySelector<HTMLElement>(selector);
    if (!container) throw new Error(`Page container not found: ${selector}`);
    return container;
  }

  static shouldWatchElements(): boolean {
    return true;
  }
}
